import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class StorageManagerService {
    constructor() { }

    // Adding default return in cases where the object being read is not a string. This is not required, but in 
    // error cases where a read happens before a write this is the value that would be returned.
    read(key: string, defaultReturn: any = '') {

        const value = sessionStorage.getItem('SSDrugProductsApp_' + key);

        return value && ( value !== 'undefined' && value !== 'null') ? JSON.parse(value) : defaultReturn;
    }

    write(key: string, value: any): void {
        sessionStorage.setItem('SSDrugProductsApp_' + key, JSON.stringify(value));
    }

    // Delete data
    public remove(key: string) {
        sessionStorage.removeItem('SSDrugProductsApp_' + key);
    }

    // Clear all storage
    public clearAll() {
        sessionStorage.clear();
    }
}
